import { GridStack } from 'gridstack';
import { easepick, RangePlugin } from '@easepick/bundle';

import utils from './utils';
import graphics from './graphics';
import ReportUtils from './reports';

class ReportPreview {
    constructor()
    {
        this.grid = null;
        this.picker = null;
        this.reports = new ReportUtils();
    }

    populateCurrentChart()
    {
        let cell = $('.tab-pane.active .by_subject .tab-pane.active [data-widget-id]');
        let subject = $('.tab-pane.active .by_subject [name=tab_subject]').val();
        this.reports.loadCell(cell, 'render', subject);
    }

    initReportPreview(container)
    {
        let preview = $('#report-preview', container);
        if (preview.length > 0) {
            this.populateCurrentChart();

            preview.on('shown.bs.tab', () => {
                this.populateCurrentChart();
            });

            preview.on('jb-after-async-fetch', () => {
                this.populateCurrentChart();
            });

            $('select[name=interval]').change(() => {
                this.populateCurrentChart();
            });
        }
    }
}

export default ReportPreview;
